import { HorizontalMenu } from 'legacy/lut/components/widgets/public/onboarding/onbPartnerForm/components/horizontalMenu/HorizontalMenu'
import { useMemo } from 'react'

import { PartnerWorkflowStatus } from 'clickNgo/entities/partner/configs'
import { IPartner } from 'clickNgo/entities/partner/models'
import { LoaderOverlay } from 'core-components/library/loader'

import { HorizontalMenuLabelWithInfo } from './components/horizontalMenuLabelWithInfo/HorizontalMenuLabelWithInfo'
import { PartnerBasicInfoWrapper } from './components/partnerBasicInfoWrapper/PartnerBasicInfoWrapper'
import { PartnerLegalInfoWrapper } from './components/partnerLegalInfoWrapper/PartnerLegalInfoWrapper'
import { PartnerDataFormKeys } from './configs'

interface IProps {
  partner: IPartner
  isInactive: boolean
  isLoading: boolean
  isDisabled?: boolean
}

export const OnbPartnerForm = ({ partner, isDisabled, isInactive, isLoading }: IProps) => {
  const basicInfoTitle = useMemo(
    () => (
      <HorizontalMenuLabelWithInfo
        isInactive={isInactive}
        title={PartnerDataFormKeys.BasicInfo}
        status={partner.workflowStatus}
        modifiedValues={partner.modifiedValues}
      />
    ),
    [partner.modifiedValues, partner.workflowStatus, isInactive]
  )

  const legalInfoTitle = useMemo(
    () => (
      <HorizontalMenuLabelWithInfo
        isInactive={isInactive}
        title={PartnerDataFormKeys.LegalInfo}
        status={partner.legalWorkflowStatus}
        modifiedValues={partner.legalModifiedValues}
      />
    ),
    [partner.legalModifiedValues, partner.legalWorkflowStatus, isInactive]
  )

  return (
    <div>
      <LoaderOverlay show={isLoading} />
      <HorizontalMenu>
        <HorizontalMenu.Item title={basicInfoTitle}>
          <PartnerBasicInfoWrapper
            partner={partner}
            isDisabled={isDisabled}
            isSaveAsDraft={partner.workflowStatus === PartnerWorkflowStatus.DRAFT}
          />
        </HorizontalMenu.Item>
        <HorizontalMenu.Item title={legalInfoTitle}>
          <PartnerLegalInfoWrapper
            partner={partner}
            isDisabled={isDisabled}
            isSaveAsDraft={partner.legalWorkflowStatus === PartnerWorkflowStatus.DRAFT}
          />
        </HorizontalMenu.Item>
      </HorizontalMenu>
    </div>
  )
}
